<div class="skidtemplateconfig-container p-4">


  <form [formGroup]="templateForm">
    <!-- Transit Days Section -->
    <div class="mb-4">
      <div class="flex align-items-center gap-3" style="width: fit-content;">
        <label for="transitDays" class="font-medium text-900">Transit Days</label>
        <p-inputNumber id="transitDays" formControlName="transitDays" (onBlur)="changeTransitDays($event)" [min]="0"
          [max]="30" [showButtons]="true" [inputStyle]="{'width': '5rem'}">
        </p-inputNumber>
      </div>
    </div>

    <!-- Weekly Schedule Table -->

    <table class="w-full">
      <!-- Table Header -->
      <thead>
        <tr class="bg-gray-50">
          <th class="text-left p-2 font-semibold text-900" style="width: 20%;">Day</th>
          <th class="text-center p-2 font-semibold text-900" style="width: 30%;">Shipping Date</th>
          <th class="text-center p-2 font-semibold text-900" style="width: 30%;">Arrival Date</th>
          <th class="text-center p-2 font-semibold text-900" style="width: 20%;"># MVPS</th>
        </tr>
      </thead>

      <!-- Table Body -->
      <tbody>
        <!-- Monday Row -->
        <tr class="border-bottom-1 surface-border">
          <td class="p-2">
            <span class="font-medium text-900">Monday</span>
          </td>
          <td class="p-2 text-center">
            <p-datePicker formControlName="monShipDay" [disabledDays]="enableMondays"
              appendTo="body" [showIcon]="true" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy"
              (onSelect)="shipDateChange('Mon',$event)" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-datePicker appendTo="body" formControlName="monArrivalDay" [showIcon]="true" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-inputNumber formControlName="monSkids" [min]="0" [max]="20" [showButtons]="true" class="w-full">
            </p-inputNumber>
          </td>
        </tr>

        <!-- Tuesday Row -->
        <tr class="border-bottom-1 surface-border">
          <td class="p-2">
            <span class="font-medium text-900">Tuesday</span>
          </td>
          <td class="p-2 text-center">
            <p-datePicker formControlName="tueShipDay" appendTo="body" [showIcon]="true" [disabledDays]="enableTuesdays"
              (onSelect)="shipDateChange('Tue',$event)" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-datePicker appendTo="body" formControlName="tueArrivalDay" [showIcon]="true" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-inputNumber formControlName="tueSkids" [min]="0" [max]="20" [showButtons]="true" class="w-full">
            </p-inputNumber>
          </td>
        </tr>

        <!-- Wednesday Row -->
        <tr class="border-bottom-1 surface-border">
          <td class="p-2">
            <span class="font-medium text-900">Wednesday</span>
          </td>
          <td class="p-2 text-center">
            <p-datePicker formControlName="wedShipDay" appendTo="body" [showIcon]="true"
              [disabledDays]="enableWednesdays" (onSelect)="shipDateChange('Wed',$event)" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-datePicker appendTo="body" formControlName="wedArrivalDay" [showIcon]="true" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-inputNumber formControlName="wedSkids" [min]="0" [max]="20" [showButtons]="true" class="w-full">
            </p-inputNumber>
          </td>
        </tr>

        <!-- Thursday Row -->
        <tr class="border-bottom-1 surface-border">
          <td class="p-2">
            <span class="font-medium text-900">Thursday</span>
          </td>
          <td class="p-2 text-center">
            <p-datePicker formControlName="thuShipDay" appendTo="body" [showIcon]="true"
              [disabledDays]="enableThursdays" (onSelect)="shipDateChange('Thu',$event)" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-datePicker appendTo="body" formControlName="thuArrivalDay" [showIcon]="true" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-inputNumber formControlName="thuSkids" [min]="0" [max]="20" [showButtons]="true" class="w-full">
            </p-inputNumber>
          </td>
        </tr>

        <!-- Friday Row -->
        <tr>
          <td class="p-2">
            <span class="font-medium text-900">Friday</span>
          </td>
          <td class="p-2 text-center">
            <p-datePicker formControlName="friShipDay" appendTo="body" [showIcon]="true" [disabledDays]="enableFridays"
              (onSelect)="shipDateChange('Fri',$event)" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-datePicker appendTo="body" formControlName="friArrivalDay" [showIcon]="true" dateFormat="mm/dd/yy"
              placeholder="mm/dd/yyyy" [disabled]="true" class="w-full">
            </p-datePicker>
          </td>
          <td class="p-2 text-center">
            <p-inputNumber formControlName="friSkids" [min]="0" [max]="20" [showButtons]="true" class="w-full">
            </p-inputNumber>
          </td>
        </tr>
      </tbody>
    </table>


  </form>

  <!-- Footer Section -->
  <div class="flex justify-content-end align-items-center mt-4 pt-3 border-top-1 surface-border">
    <div class="flex gap-2">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancel()">
      </p-button>
      <p-button label="Save Template" icon="pi pi-save" (click)="saveTemplate()" [loading]="saving">
      </p-button>
    </div>
  </div>
</div>
